<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Estadísticas</a>
  </div>
  <h1 class="ui header"><i class="icon chart bar"></i><div class="content">Estadísticas: {{year}} </div></h1>
  <div class="rightButton">
    <a class="section" v-on:click="getStats(year-1)"><i class="big arrow alternate circle down icon"></i></a>
    <a class="section" v-on:click="getStats(year+1)"><i class="big arrow alternate circle up icon"></i></a>
  </div>
  <div class="ui tabular menu">
    <a class="item active" v-on:click="goTo('/stats')">
      Todos
    </a>
    <a class="item" v-on:click="goTo('/stats/apms')">
      APMS
    </a>
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <chartjs-bar :option="myoption" :datalabel="mylabel" :labels="mylabels" :data="mydata" :bordercolor="'#00f9a9'" :backgroundcolor="'rgba(0,249,169,0.1)'"></chartjs-bar>
      </div>
    </div>
    <div class="row" style="text-align:center">
      <div class="column ">
        <div class="ui huge horizontal statistic">
          <div class="value">
            {{totala}}
          </div>
          <div class="label">PAQUETES RECOGIDOS EN <H1>{{year}}</H1></div>
        </div>
      </div>
    </div>
    <div v-if="(this.role==='master'||this.role==='admin')" class="row">
      <div class="column">
        <h4 class="ui horizontal divider header">
          <i class="bar chart icon"></i>
          Recogidas por clientes
        </h4>
        <div class="ui seven cards">
          <a class="card" v-for="data in clientData" :key="data.key" v-on:click="goTo('/stats/'+data.key)">
            <div class="image">
              <img class="ui image" v-bind:src="data.url" v-bind:alt="data.key">
            </div>
            <div class="content">
              <b class="rec">{{data.value}}</b>
            </div>
          </a>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'statIndex',
  data() {
    return {
      clientData: null,
      role: null,
      data: null,
      year: null,
      mylabels: null,
      mydata: null,
      totala: null,
      images: null,
      mylabel: 'Paquetes recogidos',
      myoption: {
        onClick: (evt, item) => {
          this.selectMonth(item[0]._model.label)
        },
        onHover: function(e) {
          var point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = 'pointer'
          else e.target.style.cursor = 'default'
        }
      }
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role
    if (this.role === 'master' || this.role === 'admin') {
      this.getImages()
    } else {
      let year = new Date().getFullYear()
      this.getStats(year)
    }

  },
  methods: {
    async getImages() {
      let year = new Date().getFullYear()
      await hapiickApi().get('/v1/images/stats?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
      })
      .catch((error) => {
        console.log('error getting images')
        console.log(error)
      })
      this.getStats(year)
    },
    getStats(year) {
      this.data = null
      this.year = year
      let hoy = new Date();
      let current_year = hoy.getFullYear();
      this.last_month = 12;
      if (this.year == current_year) {
        this.last_month = hoy.getMonth() + 1;
      }
      hapiickApi().post('/v3/stats/years', {
        admin_id: JSON.parse(localStorage.admin).id,
        year: year
      })
      .then(request => this.updateStatistics(request))
      .catch((error) => {
        console.log('error getting stats')
        console.log(error)
      })
    },
    updateStatistics(req) {
      this.data = JSON.parse(JSON.stringify(req.data.data))

      if (this.role === 'master' || this.role === 'admin') {
        let client = []
        for (var key in this.data.client) {
          let clientInfo = {}
          clientInfo.value = this.data.client[key];
          clientInfo.key = key;

          clientInfo.url = null

          if (this.images !== null) {
            let url = this.images.find((e) => {
              return (e.key === key)
            })
            if (url !== undefined) {
              clientInfo.url = url.url
            }
          }

          client.push(clientInfo)
        }
        this.clientData = client
      }


      let datuak = {...this.data.monthPicks};
      let hilabeteak = []
      let zerrenda = []

      for (let i=1; i<=this.last_month; i++) {
        hilabeteak.push(this.$months[i-1]);
        if (datuak.hasOwnProperty(i)) {
          zerrenda.push(datuak[i]);
        } else {
          zerrenda.push(0);
        }
      }
      this.mylabels = hilabeteak;
      this.mydata = zerrenda;
      this.totala=zerrenda.reduce((a, b) => a + b);
    },
    selectMonth(month) {
      let m = Object.keys(this.$months).find(key => this.$months[key] === month);
      m++;
      this.goTo('/stats/' + this.year + '/' + m)
    },
    goTo(where) {
      this.$router.push(where)
    },

  }
}
</script>

<style scoped>
.rec{
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/Stats/statsIndex.vue